import React from 'react';

import Logo from '../../../assets/logos/Ark51_VERTBLACK&BLACK.png';
import DarkThemeLogo from '../../../assets/logos/Ark51_VERTWHITE&WHITE.png';
import { useSystemColourPreference } from '../../../hooks/useSystemColourPreference';
import styles from './Table.module.scss';

export const TableLogo: React.FC = () => {
    const showDarkThemeLogo = useSystemColourPreference();

    return (
        <picture>
            <source srcSet={DarkThemeLogo} media={showDarkThemeLogo ? 'all' : 'none'} />
            <img className={styles.logoWrapper} src={Logo} />
        </picture>
    );
};
